<template>
  <b-container>
    <b-table hover responsive small :items="tickets" :fields="fields">
      <template v-slot:cell(images)="row">
        <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
          <i class="fa fa-eye" aria-hidden="true"></i>
        </b-form-checkbox>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <ul v-for="(value, key) in images" :key="key">
            <!--row.item -->
            <li v-if=" value.ticket_id == row.item.id">
              <b-img thumbnail fluid :src="value.direccion" alt="imagen del ticket"></b-img>

            </li>
          </ul>
        </b-card>
      </template>

      <template v-slot:cell(acciones)="row">
        <b-button size="sm" class="mb-1 mr-1"
          @click="callActivities(row.item, row.index, $event.target)" data-toggle="tooltip" data-placement="top"
          title="atender el ticket">

          <i class="fa fa-tasks" aria-hidden="true"></i>

        </b-button>
      </template>


      <template v-slot:cell(estatus)="row">
        <div v-if="row.item.estatus == 'Abierto'">
          <b-badge pill variant="success">{{row.item.estatus}}</b-badge>
        </div>
        <div v-else>
           <b-badge pill variant="secondary">{{row.item.estatus}}</b-badge>
        </div>


      </template>
    </b-table>
  </b-container>
</template>

<script>
import {mapActions,mapState,mapMutations} from 'vuex'


import TicketActivity from '@/components/tickets/TicketActivity.vue'
export default {
  components:{
      TicketActivity,
    },
  data: function(){
      return{
        fields:[
                    {key:'id',label:'Id',sortable:false,  thStyle: { width: "5%" },},
                    {key:'categoria',label:'Categoria',sortable:false,thStyle: { width: "5%" }},
                    {key:'titulo',label:'Título',sortable:false,thStyle: { width: "5%" }},
                    {key:'descripcion',label:'Descripción',sortable:false,thStyle: { width: "10%" }},
                    {key:'estatus',label:'Estado',thStyle: { width: "5%" }},
                    {key:'images',label:'Imagenes',thStyle: { width: "5%" }},
                    {key:'acciones', label:'Acciones',thStyle: { width: "5%" }},
        ],
      }
  },
  mounted(){
    this.init()
  },//mounted
  computed:{
    ...mapState('login',['id']),
    ...mapState('ticket',['isOk','tickets','images','total','abiertos','cerrados']),
  },
  methods:{
    ...mapActions({
      _ticketsByUser: 'ticket/fetchTicketsByUser',
      _images: 'ticket/fetchImages',
      _activity:'ticket/fetchActivity'
    }),
    ...mapMutations({
      _setTicket: 'ticket/setTicket'
    }),

    init() {
      let payload = {
        'id' : this.id
      }
      this._ticketsByUser(payload)
      this._images()
    },
    callActivities(item, index, button){
      this._setTicket(item)
      let payload = {
        'id': item.id
      }
      this._activity(payload).then(()=>{
        
        this.$router.push('ticketActivities')
      })

    },
  },
}
</script>

<style lang="scss" scoped>

</style>